import observer from "aos/src/js/libs/observer";

export function blockVideoCta() {
    const containers = document.querySelectorAll('.video-cta-block')

    if (!!window.window.IntersectionObserver) {
        containers.forEach((container) => {
            let video = container.querySelector('video'),
                observer = new IntersectionObserver((entries, observer) => {
                    entries.forEach(entry => {

                        if (entry.intersectionRatio === 1 && video.paused && container.classList.contains('init')) {
                            container.querySelector('button').classList.add('playing');
                            container.classList.remove('init')
                            video.play();
                        }

                    });
                }, {
                    threshold: 1
                });

            video.paused;
            blockVideoCtaButton(container);

            observer.observe(video)
        })
    }
}

function blockVideoCtaButton(element) {
    let btn = element.querySelector('button'),
    video = element.querySelector('video');

    btn.addEventListener('click', (event) => {
        let el = event.target,
        isPlaying = el.classList.contains('playing');

        if(isPlaying){
            video.pause()
        }else{
            video.play()
        }

        el.setAttribute('aria-pressed', isPlaying ? 'false' : 'true');
        el.setAttribute('aria-label', isPlaying ? 'Play' : 'Pause')
        el.classList.toggle('playing');

    });
}